import { Box, Typography } from '@mui/material';
import Logo from './Logo';
import { brandNameLogoKey } from '../../config/constants';

interface LogoProps {
  paddingTop?: string | number;
  gap?: string;
}
function LogoWithBrandName({ paddingTop, gap = '10px' }: LogoProps) {
  const brandNameLogo = localStorage.getItem(brandNameLogoKey);
  return (
    <Box display="flex" alignItems="center" gap={gap} paddingTop={paddingTop ?? '3%'}>
      <Logo size={33} />
      {brandNameLogo ? (
        <img src={brandNameLogo} alt="brandNameLogo" width="80%" />
      ) : (
        <Typography variant="bodyBold" textAlign="center" color="primary">
          Progress Magic
        </Typography>
      )}
    </Box>
  );
}

export default LogoWithBrandName;
